module.exports = __webpack_public_path__ + "img/quick-btn1.1337241b.png";